import {
  Button,
  CircularProgress,
  Column,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

export interface ICancelShiftLoadingDialogProps {
  isInterview: boolean;
  isError: boolean;
  onClose: () => void;
  onRetry: () => void;
}

/** Placeholder while the shift's own cancellation figures load. */
export const CancelShiftLoadingDialog = ({
  isInterview,
  isError,
  onClose,
  onRetry,
}: ICancelShiftLoadingDialogProps) => (
  <Dialog open onClose={onClose} size="small" data-testid="cancel-shift-loading-dialog">
    <DialogTitle>{isInterview ? 'Cancel Onsite Interview' : 'Cancel Shift'}</DialogTitle>
    <DialogContent>
      <Column gap={3} align="center" py={4} role="status">
        {isError ? (
          <Typography variant="body1" textAlign="center" color={colors.neutral[500]}>
            We couldn&rsquo;t load the cancellation details. Please try again.
          </Typography>
        ) : (
          <>
            <CircularProgress size={32} />
            <Typography variant="body1" textAlign="center" color={colors.neutral[500]}>
              Loading the cancellation details&hellip;
            </Typography>
          </>
        )}
      </Column>
    </DialogContent>
    <DialogActions>
      <Button
        type="button"
        variant="outlined"
        onClick={onClose}
        data-cy="cancel-shift-loading-go-back"
      >
        Go Back
      </Button>
      {isError && (
        <Button type="button" onClick={onRetry} data-cy="cancel-shift-loading-retry">
          Try Again
        </Button>
      )}
    </DialogActions>
  </Dialog>
);
